'use client';
import React from 'react';

interface Article {
  type: 'blog' | 'news' | 'event';
  categoryLabel: string;
  categoryColor: string;
  date?: string;
  title: string;
  image: string;
  alt: string;
  href: string;
}

const articles: Article[] = [
{
  type: 'blog',
  categoryLabel: 'Thought Leadership',
  categoryColor: '#00b195',
  date: '04.15.2026',
  title: 'What Developers Should Consider When Repurposing Urban Real Estate',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_10830d04f-1779936772505.png",
  alt: 'Historic urban building being repurposed into modern residential housing development',
  href: '/media-center'
},
{
  type: 'news',
  categoryLabel: 'News',
  categoryColor: '#00b9f2',
  date: '04.18.2026',
  title: 'Brickwell Housing Celebrates Grand Opening of New Affordable Community in Riverside',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1af75f13e-1777684034011.png",
  alt: 'Grand opening ceremony of new affordable housing community with residents and officials',
  href: '/media-center'
},
{
  type: 'event',
  categoryLabel: 'Event',
  categoryColor: '#f05323',
  title: 'April 10, 2026 — Brickwell Housing to Break Ground on New Senior Living Community in Westfield',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_134536bf4-1777272190712.png",
  alt: 'Groundbreaking ceremony for new senior living community with shovels and hard hats',
  href: '/media-center'
},
{
  type: 'news',
  categoryLabel: 'News',
  categoryColor: '#00b9f2',
  date: '04.10.2026',
  title: 'Brickwell Breaks Ground on Elmwood Senior Housing, Expanding Affordable Living Options',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_16f945020-1776892894546.png",
  alt: 'Groundbreaking event for Elmwood senior housing project with community members and officials',
  href: '/media-center'
}];


export default function MediaSection() {
  return (
    <section
      id="media"
      className="py-12 md:py-16 lg:py-20 bg-white">

      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px' }}>
        {/* Section Header */}
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <h2
            style={{
              fontSize: 'clamp(24px, 3vw, 36px)',
              fontWeight: 400,
              color: '#003c82',
              margin: 0,
              fontFamily: 'Montserrat, sans-serif'
            }}>

            Media Center
          </h2>
          <a
            href="/media-center"
            style={{
              color: '#003c82',
              fontSize: '14px',
              fontWeight: '600',
              textDecoration: 'none',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              fontFamily: 'Montserrat, sans-serif',
              whiteSpace: 'nowrap'
            }}>

            See All
            <svg width="8" height="14" viewBox="0 0 8 14" fill="none">
              <path d="M1 1l6 6-6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </a>
        </div>

        {/* Articles Grid — 1 col mobile, 2 col sm, 4 col lg */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {articles.map((article, idx) =>
          <article
            key={idx}
            style={{
              display: 'flex',
              flexDirection: 'column'
            }}>

              {/* Image */}
              <div style={{ overflow: 'hidden', marginBottom: '0' }}>
                <a href={article.href}>
                  <img
                  src={article.image}
                  alt={article.alt}
                  style={{
                    width: '100%',
                    height: '200px',
                    objectFit: 'cover',
                    display: 'block',
                    transition: 'transform 0.3s ease'
                  }}
                  onMouseEnter={(e) => {(e.currentTarget as HTMLImageElement).style.transform = 'scale(1.03)';}}
                  onMouseLeave={(e) => {(e.currentTarget as HTMLImageElement).style.transform = 'scale(1)';}} />

                </a>
              </div>

              {/* Meta */}
              <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                margin: '14px 0 8px'
              }}>

                <a
                href={article.href}
                style={{
                  fontSize: '12px',
                  fontWeight: '600',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  textDecoration: 'none',
                  color: article.categoryColor,
                  fontFamily: 'Montserrat, sans-serif'
                }}>

                  {article.categoryLabel}
                </a>
                {article.date &&
              <time
                style={{
                  fontSize: '12px',
                  color: '#888',
                  fontFamily: 'Montserrat, sans-serif'
                }}>

                    {article.date}
                  </time>
              }
              </div>

              {/* Title */}
              <h3
              style={{
                fontSize: '16px',
                fontWeight: 500,
                color: '#333333',
                margin: '0 0 12px',
                lineHeight: 1.4,
                fontFamily: 'Montserrat, sans-serif',
                flexGrow: 1
              }}>

                {article.title}
              </h3>

              {/* Read More */}
              <a
              href={article.href}
              style={{
                color: '#003c82',
                fontSize: '13px',
                fontWeight: '600',
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                marginTop: 'auto',
                fontFamily: 'Montserrat, sans-serif'
              }}>

                Read More
                <svg width="8" height="14" viewBox="0 0 8 14" fill="none">
                  <path d="M1 1l6 6-6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </a>
            </article>
          )}
        </div>
      </div>
    </section>);

}